import Footer from "components/footer/Footer";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import routes from "routes";
import "./pagination.css";
import Loader from "components/loader";

export default function Admin(props: { [x: string]: any }) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState([]);

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    const getActiveRoute = (routes: RoutesType[]) => {
      let activeRoute = "Main Dashboard";
      var currentUrl = window.location.href;
      var baseUrl = window.location.origin;
      var relativeUrl = currentUrl.replace(baseUrl, "").split("/");
      let breadCrum = [];
      let n = relativeUrl.length;
      const paramValue = new Map();
      for (let k = 0; k < n - 2; k++) {
        for (let index = 0; index < routes.length; index++) {
          let routeString = routes[index].path;
          let route = routeString.split("/");
          if (route.length === relativeUrl.length - 2) {
            let isMatched = true;
            for (let j = 0; j < route.length; j++) {
              if (!route[j].includes(":") && route[j] !== relativeUrl[j + 2]) {
                isMatched = false;
                break;
              } else if (route[j].includes(":")) {
                if (paramValue.has(route[j])) {
                  routeString = routeString.replace(
                    route[j],
                    paramValue.get(route[j])
                  );
                } else {
                  routeString = routeString.replace(
                    route[j],
                    relativeUrl[j + 2]
                  );
                  paramValue.set(route[j], relativeUrl[j + 2]);
                }
              }
            }
            if (isMatched) {
              breadCrum.push({
                name: routes[index].name,
                href: routes[index].layout + "/" + routeString,
              });
            }
          }
        }
        relativeUrl.pop();
      }
      // console.log(breadCrum);
      setCurrentRoute(breadCrum.reverse());
    };
    getActiveRoute(routes);
  }, [location.pathname]);

  const getModifiedRoute = (route: any, sliceVal: any) => {
    if (sliceVal > 0) {
      const modifiedRoute = route.split("/").slice(0, -sliceVal);
      return modifiedRoute.join("/");
    } else {
      return route;
    }
  };

  const getActiveNavbar = (routes: RoutesType[]): string | boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  // back-button brownsing issue - if user logouts and comes back on same page it will redirect to sign page
  const token = localStorage.getItem("token");
  const refresh_token = localStorage.getItem("refresh_token");

  if (!token && !refresh_token) {
    window.location.href = "/auth/signin";
  }

  document.documentElement.dir = "ltr";
  return (
    <>
      {!token && !refresh_token ? (
        <Loader />
      ) : (
        <>
          <div className="flex h-full w-full">
            <Sidebar open={open} onClose={() => setOpen(false)} />
            {/* Navbar & Main Content */}
            <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
              {/* Main Content */}
              <main
                className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
              >
                {/* Routes */}
                <div className="h-full">
                  <Navbar
                    onOpenSidenav={() => setOpen(true)}
                    brandText={currentRoute}
                    secondary={getActiveNavbar(routes)}
                    {...rest}
                  />
                  <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
                    <Routes>
                      {getRoutes(routes)}

                      <Route
                        path="/"
                        element={<Navigate to="/admin/announcement" replace />}
                      />
                    </Routes>
                  </div>
                  <div className="p-3">
                    <Footer />
                  </div>
                </div>
              </main>
            </div>
          </div>
        </>
      )}
    </>
  );
}
